import { Component, Input, OnInit, inject } from '@angular/core';
import { IconNames } from '@shared/enums/icon-names';
import { ThemeService } from '@core/services/theme.service';
import { themes } from '@core/constants/themes';
import { Theme } from '@support/models/theme.model';
import { OpenDialogService } from '@core/services/open-dialog.service';
import { Dealer } from '@core/models/dealer.model';
import { User } from '@core/models/user.model';
import { AuthService } from '@core/services/auth.service';
import { AppData } from '@app/shared/models/appdata.model';
import { VersionCheckComponent } from '../version-check/version-check.component';
import { MatDivider } from '@angular/material/divider';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-menu-user-info',
  templateUrl: './menu-user-info.component.html',
  styleUrls: ['./menu-user-info.component.scss'],
  imports: [MatButton, MatIcon, MatMenuTrigger, MatMenu, MatMenuItem, MatDivider, VersionCheckComponent],
})
export class MenuUserInfoComponent implements OnInit {
  private themeService = inject(ThemeService);
  openDialogService = inject(OpenDialogService);
  private authService = inject(AuthService);
  private appData = inject(AppData);

  IconNames = IconNames;
  themes = themes;

  @Input() activeDealer: Dealer;
  @Input() dealers: Dealer[];
  @Input() user: User;
  @Input() selectedTheme: Theme;
  @Input() onClose: () => void;

  appVersion = this.appData.clientVersion;
  appEnvironment = this.appData.environment;

  ngOnInit() {
    this.themeService.changeTheme(themes.find(theme => theme.name === this.selectedTheme.name));
  }

  logoff() {
    this.authService.logoff();
  }

  onChangeTheme() {
    const [lightTheme, darkTheme] = themes;
    this.themeService.changeTheme(this.selectedTheme.name === lightTheme.name ? darkTheme : lightTheme);
  }
}
